module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeAQMAAAAB/jzhAAAAA1BMVEXpywVZLSz/AAAAC0lEQVR4AWMYlAAAAJYAAZik184AAAAASUVORK5CYII="